enum EPriceListVariant {
  FILE = 'file',
  LINK = 'link',
}

export default EPriceListVariant;
